import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Malaysian NRIC generator following Single Responsibility Principle
 */
export class MyGenerator extends BaseGenerator {
  generate(options = {}) {
    const { formatted = true, birthDate = null } = options;

    let yymmdd;
    if (birthDate) {
      const date = new Date(birthDate);
      const year = date.getFullYear().toString().slice(-2);
      const month = this.padZero(date.getMonth() + 1, 2);
      const day = this.padZero(date.getDate(), 2);
      yymmdd = year + month + day;
    } else {
      const year = this.padZero(this.randomInt(0, 99), 2);
      const month = this.padZero(this.randomInt(1, 12), 2);
      const day = this.padZero(this.randomInt(1, 28), 2);
      yymmdd = year + month + day;
    }

    // State code (2 digits) - common Malaysian state codes
    const stateCodes = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16'];
    const stateCode = stateCodes[this.randomInt(0, stateCodes.length - 1)];

    // Serial number (4 digits)
    const serialNumber = this.randomDigits(4);

    const nric = yymmdd + stateCode + serialNumber;

    return formatted ? 
      `${nric.substring(0, 6)}-${nric.substring(6, 8)}-${nric.substring(8, 12)}` : 
      nric;
  }
}